import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';

import { DialogContentComponent } from './dialog-content.component';

export interface SimpleDialogData {
    title: string;
    content: string;
}

@Component({
    imports: [MatDialogModule, TrustAsHtmlPipe, DialogContentComponent],
    templateUrl: 'simple-dialog.html',
})
export class SimpleDialogComponent {
    data = inject<SimpleDialogData>(MAT_DIALOG_DATA);
}
